import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions/index'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from '@material-ui/core';

const styles = theme => ({

});

class UserNoteDialog extends Component {
    updateTabName = (event) => {
        this.props.editTabName(event.target.value);
    }

    render() {
        const { dialog_title, edit_tab_name } = this.props;

        return (
            <Dialog
                open={this.props.is_dialog_open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{dialog_title}</DialogTitle>
                <DialogContent>
                    <TextField
                        value={edit_tab_name}
                        onChange={this.updateTabName}
                        label="Tab Name"
                        margin="normal"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={() => this.props.handleSubmit(edit_tab_name)} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        getUserNoteList:       Actions.getUserNoteList,
        editTabName:           Actions.editTabName,
    }, dispatch);
}

function mapStateToProps({note, auth})
{
    return {
        current_user_note_detail_id: note.user_note.current_user_note_detail_id,
        userNoteList:                note.user_note.userNoteList,
        current_note_text:           note.user_note.current_note_text,
        edit_tab_name:               note.user_note.edit_tab_name,
        auth:                        auth,
    }
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(UserNoteDialog));



// WEBPACK FOOTER //
// src/main/components/note/UserNoteDialog.js